export var eligibilitySteps = [
    {
        stepId: 'eligibility',
        title: 'Eligibility Check',
        questions: [
            {
                questionKey: 'AnnualRevenue',
                question: 'What is your annual revenue / payroll?',
                inputType: 'money',
                required: true,
                min: 0,
                max: 4999999,
                validation: [{ type: 'pattern', pattern: '^[^.]*$' }],
                uiValidation: {
                    range: 'Revenue must be less than $5,000,000 to be eligible.',
                    pattern: 'Please enter a dollar amount without cents.'
                }
            },
            {
                questionKey: 'NumberOfEmployees',
                question: 'How many employees work for your company?',
                inputType: 'number',
                required: true,
                min: 1,
                max: 100,
                uiValidation: {
                    range: 'The number of employees must be between 1 and 100 to be eligible.'
                }
            },
        ]
    },
    {
        stepId: 'details',
        title: 'Business Information',
        questions: [
            {
                questionKey: 'State',
                question: 'What state is your business located in?',
                inputType: 'autocomplete',
                required: true,
                searchable: true
            },
            {
                questionKey: 'ClassCode',
                question: 'What is your business class?',
                inputType: 'autocomplete',
                searchable: true,
                required: true,
                helper: 'Please select the best match for your business activity.'
            },
        ]
    },
];
